import React, { useState, useEffect } from "react";
import DownloadingLogo from "../../assets/icons/DownloadingLogo";
import EsemieLoaderLogo from "../../assets/icons/EsemieLoaderLogo";
import PageLoader from "../common/PageLoader";
import styles from '../../components/common/PageLoader/loadingSpinner.module.css';

const LoginLoader = () => {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev === 3 ? 1 : prev + 1));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center fixed top-0 bottom-0 left-0 right-0 h-screen w-screen bg-[#F2F9FD]">
      <div className="flex flex-col relative items-center gap-6">
        <div    data-testid="page-1"
            className="absolute inset-0 flex items-center justify-center">
        <div className={styles.spinner_box}>
                <div className={styles.spinner_card}>
                    <EsemieLoaderLogo />
                </div>
                <div className={styles.spinner}></div>
            </div>
        </div>
        <div className="text-xl font-medium text-gray-800 mt-4 relative top-20 left-5 w-full ">
          Logging you in
          <span className="inline-block w-12">
            {Array(dotCount).fill('.').join('')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoginLoader;